import {onReady} from "../../../../../modules/vegas/js/util";

function ready() {
	if (!App.jivo.id) {
		return;
	}

	if (App.env !== 'production') {
		return;
	}

	setTimeout(() => {
		let css = document.querySelector('.jv-css');
		if (css) css.remove();

		let script = document.createElement('script');

		script.setAttribute('src',`//code-eu1.jivosite.com/widget/${App.jivo.id}`);
		script.setAttribute('id', 'jivo');
		script.onload = () => {
			window.jivo_init();
		};
		document.body.appendChild(script);
	}, 100);
}

onReady(ready);
typeof onTurboRender !== 'undefined' && onTurboRender(ready);
